import * as React from 'react';
import { useState } from "react";
import Submenu from "../../components/Submenu/Submenu";
import VolumePromotionForm from "../../components/VolumePromotions/VolumePromotionForm";
import AppMenus from "../../config/appMenus";
import AppRoutes from "../../config/appRoutes";
var VolumePromotion = function () {
    var appMenus = new AppMenus();
    var _a = useState(false), isEdit = _a[0], setIsEdit = _a[1];
    var subMenu = null;
    if (isEdit) {
        subMenu = React.createElement(Submenu, { menuItems: appMenus.subMenuItems[AppRoutes.editVolumePromotion.key] });
    }
    return (React.createElement("div", { className: "container-fluid" },
        React.createElement("div", { className: "animated fadeIn" },
            React.createElement("h1", { className: "display-3" }, "\u041D\u043E\u0432\u0430 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0435\u043D\u0430 \u043F\u0440\u043E\u043C\u043E\u0446\u0438\u044F"),
            React.createElement("hr", null),
            React.createElement("div", { className: "row" },
                isEdit ? subMenu : null,
                React.createElement("div", { className: "col-md-5 " + (isEdit ? '' : 'offset-md-4') },
                    React.createElement(VolumePromotionForm, { setEdit: setIsEdit }))))));
};
export default VolumePromotion;



//////////////////
// WEBPACK FOOTER
// ./src/views/VolumePromotions/VolumePromotion.tsx
// module id = 510
// module chunks = 0